import { AxiosResponse } from 'axios';
import { call, fork, put, takeEvery } from 'redux-saga/effects';

import { DataUnitDataListTransitionResponse } from '../domain/unitDataList/types';

import {
  DataUnitDataListTransitionActionCreators,
  DataUnitDataListTransitionActionTypes,
  FetchDataUnitDataListTransitionAction,
} from '../redux/server/dataUnitDataListTransition';
import { Api, buildConfig } from '../utils/api';
import { handleErrorSaga } from './errorSaga';

/**
 * 指定した検索条件で推移データをAPIから取得する
 * @param api API
 * @param action FetchData
 */
export function* fetchDataUnitDataListTransitionSagas(
  api: Api,
  action: FetchDataUnitDataListTransitionAction
) {
  try {
    yield put(
      DataUnitDataListTransitionActionCreators.fetchDataUnitDataListTransitionRequestAction()
    );

    const response: AxiosResponse<DataUnitDataListTransitionResponse> =
      yield call(
        api.get,
        '/data/dai/transition',
        buildConfig(action.payload.params)
      );

    const dataUnitDataListTransition = response.data;

    yield put(
      DataUnitDataListTransitionActionCreators.fetchDataUnitDataListTransitionSuccessAction(
        dataUnitDataListTransition
      )
    );
  } catch (error: unknown) {
    yield put(
      DataUnitDataListTransitionActionCreators.renewDataUnitDataListTransitionAction()
    );
    yield fork(handleErrorSaga, error);
  }
}

function* handleFetchDataUnitDataListTransitionSaga(api: Api) {
  yield takeEvery(
    DataUnitDataListTransitionActionTypes.FETCH_DATA_UNIT_DATA_LIST_TRANSITION,
    fetchDataUnitDataListTransitionSagas,
    api
  );
}

export function* dataUnitDataListTransitonSaga(context: { api: Api }) {
  yield fork(handleFetchDataUnitDataListTransitionSaga, context.api);
}
